module.exports = __webpack_public_path__ + "static/media/10_before.faa558c0.jpg";